const paragraphs = [
  "Mia Cho is a New York–based womenswear designer whose work explores diverse fabric manipulation, playful childhood fantasy, and a Y2K sensibility.",
  "Trained in fashion business and textile science in Seoul and currently pursuing an MFA in Fashion Design at Parsons, Cho approaches clothing as both a technician and a storyteller. Her practice combines a playful sensibility and body-conscious silhouettes with couture-informed craftsmanship and material experimentation.",
  "Drawing from Korean cultural memory, youth subcultures, school uniforms, nightlife, and personal fantasy, she translates highly specific references into clothes that feel immediate, expressive, and wearable.",
  "Across her collections, Cho explores contradictions between refinement and humor, discipline and rebellion, ornament and utility, and tradition and contemporary desire. Balancing the sensibility of couture with the accessibility of ready-to-wear, she introduces unexpected materials, intricate surface treatments, and playful interventions to transform familiar garments into something slightly unfamiliar.",
  "At the center of her practice is a pursuit of Elegant Innovation — clothing that carries the precision and imagination of couture while remaining connected to the realities and pleasures of everyday dressing. Working between wearability and fantasy, Cho creates clothes that can be lived in without losing their sense of wonder.",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative px-6 md:px-10 lg:px-16 py-28 md:py-40"
    >
      {/* Tiny eyebrow */}
      <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.22em] text-black/60">
        <span>(01) — About</span>
        <span className="hidden md:inline">A short note</span>
      </div>

      <div className="mt-14 md:mt-24 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20">
        {/* Pull quote / big statement */}
        <h2
          data-testid="about-heading"
          className="lg:col-span-5 font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight reveal"
        >
          <span className="italic text-neon-pink">Elegant Innovation</span> —{" "}
          couture precision meets everyday pleasure.
        </h2>

        {/* Body copy */}
        <div className="lg:col-span-7 space-y-6 max-w-[62ch]">
          {paragraphs.map((p, i) => (
            <p
              key={i}
              data-testid={`about-paragraph-${i}`}
              className={`text-base md:text-lg leading-relaxed reveal ${
                i === 0 ? "text-black/95" : "text-black/70"
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              {p}
            </p>
          ))}
        </div>
      </div>

      {/* Meta facts */}
      <dl className="mt-20 md:mt-28 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-black/10 pt-10 max-w-5xl">
        {[
          ["Based", "New York"],
          ["From", "Seoul, KR"],
          ["Focus", "Womenswear"],
          ["Study", "MFA · Parsons"],
        ].map(([k, v]) => (
          <div key={k} className="reveal">
            <dt className="font-mono text-[10px] uppercase tracking-[0.22em] text-black/40">
              {k}
            </dt>
            <dd className="mt-2 font-display text-2xl">{v}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
